import {onRedirect, pageData} from "@/helpers/CypressHelper";
import Localizer from "@/localization/Localizer";
import RentaEasyConstants from "@/helpers/RentaEasyConstants";
import path from "path";

describe('GetReportModal button visibility and functionality', () => {
    before(() => {
    });

    beforeEach(() => {
        cy.useSharedAdminUserSession();

        pageData().common.interceptFeatureFlags([
            {flagName: RentaEasyConstants.featureFlagConstructionSiteNewEquipmentPage, enabled: true},
            {flagName: RentaEasyConstants.featureFlagRentalReturnRequest, enabled: true},
            {flagName: RentaEasyConstants.featureFlagServicesView, enabled: true},
        ]);

        cy.visit('frontpage');
        onRedirect(() => cy.visit(`${Localizer.pageRoutesConstructionSiteDetails}?id=20c46273-6c09-4c7d-98bf-300071dfc1e2`));

        pageData().constructionSite.equipment.tab().click();
    });

    it('Should display GetReportModal button on screens wider than 768px', () => {
        cy.viewport(769, 800);
        pageData().constructionSite.equipment.buttons.getReport().should('be.visible');
    });

    it('Should hide GetReportModal button on screens smaller than 768px', () => {
        cy.viewport(767, 800);
        pageData().constructionSite.equipment.buttons.getReport().should('not.be.visible');
    });

    it('Should open GetReportModal when button is clicked', () => {
        cy.viewport(769, 800);
        pageData().constructionSite.equipment.buttons.getReport().click();
        pageData().constructionSite.equipment.modals.getReportModal().should('be.visible');
    });

    it('Repeatedly opening and closing modal should work', () => {
        cy.viewport(769, 800);
        openAndCloseModal();
        openAndCloseModal();
    });

    it('Should open GetReportModal, click download button, and verify file download', () => {
        const folder = Cypress.config('downloadsFolder');
        const namePrefix = Localizer.enumScheduleActionConstructionSiteEquipmentList;

        cy.viewport(769, 800);

        cy.wrap(null).then(() => {
            return pageData().constructionSite.name().invoke('text').then((text) => text.trim());
        }).then((name) => {
            return pageData().constructionSite.owner().invoke('text').then((owner) => {
                const match = owner.match(/([\w\s]+) \(/);
                const ownerName = match ? match[1].trim() : '';
                const filename = `${namePrefix}--${new Date().toISOString().split('T')[0]} ${name} ${ownerName}.csv`;
                const filePath = path.join(folder, filename);

                cy.log(`Expected filename: ${filename}`);

                pageData().constructionSite.equipment.buttons.getReport().click();
                pageData().constructionSite.equipment.modals.getReportModal().should('be.visible');

                pageData().constructionSite.equipment.modals.getReportModalElement.buttons.downloadCsv().click();

                cy.readFile(filePath, {timeout: 10000}).should('exist');
            });
        });
    });

    const openAndCloseModal = () => {
        pageData().constructionSite.equipment.buttons.getReport().click();
        const getReportModal = pageData().constructionSite.equipment.modals.getReportModal();
        getReportModal.should('be.visible');
        getReportModal.find('.toolbar').click();
        pageData().constructionSite.equipment.modals.getReportModal().should('not.exist');
    };
});